import React from "react";
import { useSelector } from "react-redux";
import useShowMovieTrailer from "../../hooks/useShowMovieTrailer";
import { RootState } from "../../store";

interface ShowMovieVideoProps {
  movieId: string;
}

const ShowMovieVideo: React.FC<ShowMovieVideoProps> = ({ movieId }) => {
  const trailerVideo = useSelector((store: RootState) => store.movies?.trailerVideo);
  useShowMovieTrailer(movieId);

  return (
    <div className="w-full h-full relative overflow-hidden pointer-events-none">
      {/* Invisible overlay to prevent hover interactions and standard iframe behavior */}
      <div className="absolute inset-0 z-10"></div>

      {trailerVideo ? (
        <iframe
          className="w-full h-full scale-[1.3] md:scale-[1.1]"
          src={`https://www.youtube-nocookie.com/embed/${trailerVideo?.key}?autoplay=1&mute=1&controls=0&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3&loop=1&playlist=${trailerVideo?.key}`}
          title="Movie Trailer"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      ) : (
        <div className="w-full h-full flex items-center justify-center bg-black text-zinc-600 text-xl font-bold uppercase tracking-widest animate-pulse">
          Cinematic Preview Loading...
        </div>
      )}
    </div>
  );
};

export default ShowMovieVideo;
